import { useEffect, useState } from 'react';
import { motion, useSpring, useScroll } from 'framer-motion';

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const [isVisible, setIsVisible] = useState(false);

  // Smooth spring animation for the progress bar
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  // Show progress bar only after initial scroll
  useEffect(() => {
    const unsubscribe = scrollYProgress.on('change', (latest) => {
      setIsVisible(latest > 0.01);
    });

    return () => unsubscribe();
  }, [scrollYProgress]);

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-[100] h-[2px] origin-left"
      style={{
        scaleX,
        opacity: isVisible ? 1 : 0,
        background: 'linear-gradient(90deg, #10b981 0%, #34d399 50%, #10b981 100%)',
        boxShadow: '0 0 10px rgba(16, 185, 129, 0.5)',
      }}
      initial={{ opacity: 0 }}
      transition={{ opacity: { duration: 0.2 } }}
    />
  );
}
